import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_ENT_VISTAS,
  ALL_ENT_VISTAS,
  LOADING_ALL_ENT_VISTAS,
} from './EntVistasReducer';
import {
  allEntVistasService,
  deleteEntVistasService,
  oneEntVistasService,
  saveEntVistasService,
} from './EntVistasService';

export const allEntVistasAction = async (
  { dispatch, isLogin = false },
  params,
) => {
  try {
    dispatch({ type: LOADING_ALL_ENT_VISTAS, payload: true });
    const res = await allEntVistasService(params);
    if (!isLogin) {
      dispatch({ type: ALL_ENT_VISTAS, payload: res.data });
    }
    dispatch({ type: LOADING_ALL_ENT_VISTAS, payload: false });
    return res.data.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ENT_VISTAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntVistasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEntVistasService(id, data);
    notify(res.data.message);
    await allEntVistasAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntVistasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ENT_VISTAS, payload: data });
};

export const oneEntVistasAction = async (dispatch, id) => {
  try {
    const res = await oneEntVistasService(id);
    await setActivoEntVistasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntVistasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntVistasService(id);
    notify(res.data.message);
    await setActivoEntVistasAction(dispatch, null);
    await allEntVistasAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
